import { useState } from "react";
import { Building2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { generateCrossScopeToken } from "@/features/auth/services/crossScope.service";
import { ADMIN_APP_URL } from "@/shared/configs/adminApp.config";
import { cn } from "@/shared/utils/style.util";

const LABEL = "Espace élu(e)";

type AdminSpaceLinkProps = { className?: string };

export const AdminSpaceLink = ({ className }: AdminSpaceLinkProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleAutoLogin = async () => {
    if (isLoading) return;
    setIsLoading(true);

    try {
      const response = await generateCrossScopeToken();
      window.open(`${ADMIN_APP_URL}/auto-login#login_token=${response.login_token}`, "_blank");
    }
    catch {
      window.open(ADMIN_APP_URL, "_blank");
      toast.error("Connexion automatique impossible", { description: "Vous avez été redirigé vers la page de connexion." });
    }
    finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleAutoLogin}
      className={cn("cursor-pointer w-full", className)}
    >
      {isLoading
        ? <Loader2 className="mr-2 shrink-0 animate-spin" size={20} />
        : <Building2 className="mr-2 shrink-0" size={20} />}
      {LABEL}
    </button>
  );
};
